import "../Styles/Business_set.css";
import { getData, saveData } from "../utils/store-data";
import Select, { components } from "react-select";

import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  GOOGLE_USER,
  LOGIN_BY,
  PHNO,
  PROFILE_LOGIN,
  USER_EMAIL,
  USER_ID,
} from "../utils/store-data-constants";

import {
  check_bussiness_name,
  create_agent,
  update_profile_photo,
  get_states,
  get_cities,
  check_email,
  update_business_logo,
  update_promotional_images,
} from "../api/serverWrapper";

import { useEffect, useState } from "react";

import Agent from "../components/Agent";
import UserInfo from "../components/UserInfo";

import { useNavigate } from "react-router-dom";

import { customStylesbusiness } from "../utils/commonFunctions";

import {
  loginByEmail,
  loginByGoogle,
  loginByPhoneNo,
} from "../utils/Constants";

import { useMasterData } from "../context/MasterDataContext";

import BusinessStepper from "../components/businessSetup/BusinessStepper";
import BusinessOverviewSection from "../components/businessSetup/BusinessOverviewSection";
import BusinessServiceSection from "../components/businessSetup/BusinessServiceSection";
import BusinessProfileSection from "../components/businessSetup/BusinessProfileSection";
import ReviewBusinessPage from "../components/businessSetup/ReviewBusinessPage";
import PaymentPage from "../components/businessSetup/PaymentPage";
import BusinessSetupHeader from "../screen/BusinessSetupHeader";
import BusinessMediaSection from "../components/businessSetup/BusinessMediaSection";
import BusinessContactDetails from "../components/businessSetup/BusinessContactDetails";
import BusinessPricingDetails from "../components/businessSetup/BusinessPricingDetails";

const cleanSelectStyles = {
  ...customStylesbusiness,

  option: (base) => ({
    ...base,
    backgroundColor: "white",
    color: "#333",
    cursor: "pointer",

    ":hover": {
      backgroundColor: "#f3f4f6",
    },
  }),

  multiValue: (base) => ({
    ...base,
    backgroundColor: "#f1f5f9",
  }),
};

function Business_set_up() {
  const {
    religionMasterData,
    allCasteMasterData,
    communityMasterData,
    languageMasterData,
    allCountyMasterData,
  } = useMasterData();

  const navigate = useNavigate();

  const [currentStep, setCurrentStep] = useState(1);
  const [showSuccess, setShowSuccess] = useState(false);

  const [showOverlayLoader, setShowOverlayLoader] = useState(false);

  let [agentData, setAgentData] = useState(new Agent());

  let [userData, setUserData] = useState(new UserInfo());

  let [loginby, setLoginby] = useState(loginByPhoneNo);

  const [businessName, setBusinessName] = useState("");

  const [agentName, setAgentName] = useState("");

  let [Email, setEmail] = useState("");

  const [experience, setExperience] = useState("");

  const [address, setAddress] = useState("");

  const [description, setDescription] = useState("");

  const [PhoneNumber, setPhoneNumber] = useState("");

  const [religion, setReligion] = useState(religionMasterData || []);

  const [caste, setCaste] = useState(allCasteMasterData || []);

  const [communityList, setCommunity] = useState(communityMasterData || []);

  const [languages, setLanguages] = useState(languageMasterData || []);

  const [countries, setCountries] = useState([]);

  const [countryCode, setCountryCode] = useState("");

  const [states, setStates] = useState([]);

  const [selectedState, setSelectedState] = useState(null);

  const [cities, setCities] = useState([]);

  const [selectedCity, setSelectedCity] = useState(null);

  const [selectedReligion, setSelectedReligion] = useState([]);

  const [selectedCaste, setSelectedCaste] = useState([]);

  const [selectedCommunities, setSelectedCommunities] = useState([]);

  const [selectedLanuages, setSelectedLanguages] = useState([]);

  const defaultImage = require("../assests/images/profile.png");

  const [agentProfilePreview, setAgentProfilePreview] = useState("");
  const [agentProfileFile, setAgentProfileFile] = useState(null);

  const [businessLogoPreview, setBusinessLogoPreview] = useState("");
  const [businessLogoFile, setBusinessLogoFile] = useState(null);

  const [promoImagePreviews, setPromoImagePreviews] = useState([]);
  const [promoImageFiles, setPromoImageFiles] = useState([]);

  const [businessImageSource, setbusinessImageSource] = useState("");
  const [agentImage, setAgentImage] = useState("");
  const [promoImages, setPromoImages] = useState([]);

  const [promotionalFiles, setPromotionalFiles] = useState([]);

  let [selectedAgentImage, setSelectedAgentImage] = useState("");
  const [businessRegistrationNo, setBusinessRegistrationNo] = useState("");
  const [businessContactNo, setBusinessContactNo] = useState("");
  const [alternateContactNo, setAlternateContactNo] = useState("");
  const [sameAsPersonal, setSameAsPersonal] = useState(false);
  const [businessEmail, setBusinessEmail] = useState("");
  const [website, setWebsite] = useState("");

  const [pricingModel, setPricingModel] = useState("One time payment");
  const [pricingAmount, setPricingAmount] = useState("$12 per 15 matches");
  const [paymentMethods, setPaymentMethods] = useState([
    { value: "Bank transfer", label: "Bank transfer" },
    { value: "UPI", label: "UPI" },
  ]);

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    loadInitialData();
  }, []);

  const nextStep = () => {
    setCurrentStep((prev) => prev + 1);
  };

  const prevStep = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const loadInitialData = async () => {
    try {
      const loginMethod = Number(await getData(LOGIN_BY));

      if (loginMethod === loginByEmail) {
        let mail = await getData(USER_EMAIL);

        loginby = loginByEmail;

        setLoginby(loginby);

        Email = mail;

        setEmail(Email);
      }

      const googleUserStr = await getData(GOOGLE_USER);

      const googleUser = JSON.parse(googleUserStr);

      if (googleUser) {
        Email = googleUser.email;

        setEmail(Email);

        setAgentName(googleUser.name);

        setbusinessImageSource(googleUser.picture);

        loginby = loginByGoogle;

        setLoginby(loginby);
      }

      await fetchCountries();

      let phno = await getData(PHNO);

      setPhoneNumber(phno);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCountries = async () => {
    try {
      const data = allCountyMasterData;

      if (data) {
        const formatted = data.map((c) => {
          const code = c.phonecode.startsWith("+")
            ? c.phonecode
            : `+${c.phonecode}`;

          return {
            value: c.isoCode,
            label: `${c.name} (${code})`,
            name: c.name,
            phoneCode: c.phonecode,
          };
        });

        setCountries(formatted);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (countryCode) {
      (async () => {
        try {
          const res = await get_states(countryCode);

          if (res.success) {
            const formattedStates = res.data.map((s) => ({
              value: s.isoCode,
              label: s.name,
              countryCode: s.countryCode,
            }));

            setStates(formattedStates);

            setSelectedState(null);

            setCities([]);
          }
        } catch (error) {
          console.error(error);
        }
      })();
    }
  }, [countryCode]);

  useEffect(() => {
    if (countryCode && selectedState) {
      (async () => {
        try {
          const res = await get_cities(countryCode, selectedState.value);

          if (res.success) {
            const formattedCities = res.data.map((c) => ({
              value: c.name,
              label: c.name,
            }));

            setCities(formattedCities);

            setSelectedCity(null);
          }
        } catch (error) {
          console.error(error);
        }
      })();
    }
  }, [selectedState, countryCode]);

  const ReligionOptions = [
    { value: "all", label: "All Religions" },

    ...religion.map((item) => ({
      value: item.ReligionId,
      label: item.ReligionName,
    })),
  ];

  const filteredCastes =
    selectedReligion.includes("all") || selectedReligion.length === 0
      ? caste
      : caste.filter((c) => selectedReligion.includes(c.ReligionId));

  const casteOptions = [
    { value: "all", label: "All Castes" },

    ...filteredCastes.map((item) => ({
      value: item.CasteL2Id,
      label: item.CasteName,
    })),
  ];

  const communiteOptions = [
    { value: "all", label: "All Communities" },

    ...communityList.map((item) => ({
      value: item.CommunitiesId,
      label: item.CommunitiesName,
    })),
  ];

  const langOptions = [
    { value: "all", label: "All Languages" },

    ...languages.map((item) => ({
      value: item.LangId,
      label: item.LangDesc,
    })),
  ];

  const CheckboxOption = (props) => {
    return (
      <components.Option {...props}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <input
            type="checkbox"
            checked={props.isSelected}
            readOnly
            style={{
              width: 16,
              height: 16,
              cursor: "pointer",
            }}
          />

          <span>{props.label}</span>
        </div>
      </components.Option>
    );
  };

  // const handleImageSelection = (event) => {
  //   const file = event.target.files[0];

  //   if (!file) return;

  //   setbusinessImageSource(URL.createObjectURL(file));

  //   selectedAgentImage = file;

  //   setSelectedAgentImage(selectedAgentImage);
  // };

  const handleAgentProfileSelection = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    setAgentProfilePreview(URL.createObjectURL(file));

    setAgentProfileFile(file);
  };

  // const handleAgentImageSelection = (event) => {
  //   const file = event.target.files[0];

  //   if (!file) return;
  //   setBusinessLogoFile(file);
  //   setAgentImage(URL.createObjectURL(file));
  // };

  const handleBusinessLogoSelection = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    setBusinessLogoFile(file);

    setBusinessLogoPreview(URL.createObjectURL(file));
  };

  const checkBussinessName = async (businessName) => {
    try {
      const response = await check_bussiness_name({
        BusinessName: businessName,
      });
      return response;
    } catch (error) {
      console.log("Error checking business name:", error);
      return null;
    }
  };

  const goToReviewPage = async () => {
    const valid = await validateStepOne();

    if (!valid) return;

    setCurrentStep(2);
  };

  const validateStepOne = async () => {
    setIsSubmitting(true);

    try {
      const userId = await getData(USER_ID);

      let code = countries.find((id) => id.value === countryCode)?.phoneCode;

      /* =========================
       USER DATA
    ========================= */

      userData.UserId = userId ? Number(userId) : -1;

      userData.PhoneNumber = PhoneNumber;

      userData.FirstName = agentName;

      userData.CountyCode = code;

      userData.EMail = Email;

      userData.LoginBy = loginby;

      /* =========================
       AGENT DATA
    ========================= */

      agentData.BusinessName = businessName;

      agentData.BusinessAddress = address;

      agentData.BusinessDescription = description;

      agentData.BusinessExperience = experience;

      agentData.ReligionsServe = selectedReligion.includes("all")
        ? ["all"]
        : selectedReligion.map((item) => item.ReligionId);

      agentData.CastesServe = selectedCaste.includes("all")
        ? ["all"]
        : selectedCaste.map((x) => x.CasteL2Id);

      agentData.CommunitesServe = selectedCommunities.includes("all")
        ? ["all"]
        : selectedCommunities.map((x) => x.CommunitiesId);

      agentData.LanguagesServe = selectedLanuages.includes("all")
        ? ["all"]
        : selectedLanuages.map((x) => x.LangId);

      agentData.BusinessContactNo = businessContactNo;
      agentData.AlternativeBusinessPhoneNumer = alternateContactNo;
      agentData.BusinessOfficialWebsite = website;
      agentData.BusinessEmail = businessEmail;
      agentData.BusinessRegistrationNo = businessRegistrationNo;

      /* =========================
       VALIDATIONS
    ========================= */

      if (!agentName.trim()) {
        alert("Please enter your Agent Name.");

        setIsSubmitting(false);

        return false;
      }

      if (!businessName.trim()) {
        alert("Please enter your Business Name.");

        setIsSubmitting(false);

        return false;
      }

      /* BUSINESS NAME CHECK */

      const nameCheck = await checkBussinessName(businessName);

      if (nameCheck && !nameCheck.success) {
        alert("This Business Name already exists.");

        setIsSubmitting(false);

        return false;
      }

      if (!experience.trim()) {
        alert("Please enter Total years of business experience.");

        setIsSubmitting(false);

        return false;
      }

      if (!countryCode) {
        alert("Please Select Country.");

        setIsSubmitting(false);

        return false;
      }

      if (!selectedState) {
        alert("Please Select State.");

        setIsSubmitting(false);

        return false;
      }

      if (!selectedCity) {
        alert("Please Select City.");

        setIsSubmitting(false);

        return false;
      }

      if (!address.trim()) {
        alert("Please enter your Business Address.");

        setIsSubmitting(false);

        return false;
      }

      if (businessContactNo && businessContactNo.length !== 10) {
        alert("Business Contact Number must be 10 digits");
        setIsSubmitting(false);
        return;
      }

      if (alternateContactNo && alternateContactNo.length !== 10) {
        alert("Alternative Contact Number must be 10 digits");
        setIsSubmitting(false);
        return;
      }

      /* LOGIN VALIDATIONS */

      if (loginby === loginByPhoneNo) {
        if (!PhoneNumber) {
          alert("Phone number is missing.");

          setIsSubmitting(false);

          return false;
        }
      }

      if (loginby === loginByGoogle) {
        if (!Email) {
          alert("Email is missing.");

          setIsSubmitting(false);

          return false;
        }
      }

      /* RELIGION */

      if (selectedReligion.length <= 0) {
        alert("Select Religion to Serve.");

        setIsSubmitting(false);

        return false;
      }

      /* CASTE */

      if (selectedCaste.length <= 0) {
        alert("Select Caste to Serve.");

        setIsSubmitting(false);

        return false;
      }

      /* COMMUNITIES */

      if (selectedCommunities.length <= 0) {
        alert("Select Communities to Serve.");

        setIsSubmitting(false);

        return false;
      }

      /* LANGUAGES */

      if (selectedLanuages.length <= 0) {
        alert("Select Languages to Serve.");

        setIsSubmitting(false);

        return false;
      }

      /* EMAIL CHECK */

      if (loginby === loginByPhoneNo && Email && Email.trim()) {
        const emailCheck = await check_email(Email);

        if (!emailCheck.success) {
          alert(emailCheck.message || "Email already exists");

          setIsSubmitting(false);

          return false;
        }
      }

      /* ADDRESS */

      agentData.address.CountryId = countryCode;

      agentData.address.StateId = selectedState.value;

      agentData.address.CityId = selectedCity.value;

      delete agentData.address.AddressDetails;

      delete agentData.address.ResidenceId;

      delete agentData.address.CitizenshipId;

      delete agentData.address.Ethinicity;

      /* CLEAN USER DATA */

      Object.keys(userData).forEach((key) => {
        if (!userData[key]) {
          delete userData[key];
        }
      });

      delete userData.UserLanguage;

      agentData.userInfo = userData;

      console.log(agentData);

      setIsSubmitting(false);

      return true;
    } catch (error) {
      console.log(error);

      setIsSubmitting(false);

      return false;
    }
  };

  const CreateAgent = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      const resp = await create_agent(agentData);
      console.log(resp);

      if (resp.code === 200) {
        await saveData(USER_ID, resp.data.User.UserId);

        await saveData(AGENT_LOGIN, true);

        await saveData(CLIENT_LOGIN, false);

        await saveData(PROFILE_LOGIN, false);

        if (agentProfileFile) {
          await doUpdateProfileImage(resp.data.User.UserId, agentProfileFile);
        }

        if (businessLogoFile) {
          await update_business_logo(resp.data.User.UserId, businessLogoFile);
        }

        if (promoImageFiles.length > 0) {
          await update_promotional_images(
            resp.data.User.UserId,
            promoImageFiles,
          );
        }

        localStorage.removeItem(GOOGLE_USER);

        setShowSuccess(true);
        setIsSubmitting(false);
      } else {
        alert(resp.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const doUpdateProfileImage = async (id, selectedFile) => {
    try {
      await update_profile_photo(id, selectedFile);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <BusinessSetupHeader name={"Agent Sign up | Business setup"} />

      <div className="Business_background_color">
        <BusinessStepper currentStep={currentStep} prevStep={prevStep} />

        {currentStep === 1 && (
          <>
            <BusinessOverviewSection
              businessName={businessName}
              setBusinessName={setBusinessName}
              agentName={agentName}
              setAgentName={setAgentName}
              experience={experience}
              setExperience={setExperience}
              Email={Email}
              setEmail={setEmail}
              countries={countries}
              countryCode={countryCode}
              setCountryCode={setCountryCode}
              states={states}
              selectedState={selectedState}
              setSelectedState={setSelectedState}
              cities={cities}
              selectedCity={selectedCity}
              setSelectedCity={setSelectedCity}
              address={address}
              setAddress={setAddress}
              description={description}
              setDescription={setDescription}
              loginby={loginby}
              businessRegistrationNo={businessRegistrationNo}
              setBusinessRegistrationNo={setBusinessRegistrationNo}
            />

            <BusinessContactDetails
              businessContactNo={businessContactNo}
              setBusinessContactNo={setBusinessContactNo}
              alternateContactNo={alternateContactNo}
              setAlternateContactNo={setAlternateContactNo}
              sameAsPersonal={sameAsPersonal}
              setSameAsPersonal={setSameAsPersonal}
              businessEmail={businessEmail}
              setBusinessEmail={setBusinessEmail}
              website={website}
              setWebsite={setWebsite}
            />

            <BusinessServiceSection
              ReligionOptions={ReligionOptions}
              casteOptions={casteOptions}
              communiteOptions={communiteOptions}
              langOptions={langOptions}
              selectedReligion={selectedReligion}
              setSelectedReligion={setSelectedReligion}
              selectedCaste={selectedCaste}
              setSelectedCaste={setSelectedCaste}
              selectedCommunities={selectedCommunities}
              setSelectedCommunities={setSelectedCommunities}
              selectedLanuages={selectedLanuages}
              setSelectedLanguages={setSelectedLanguages}
              CheckboxOption={CheckboxOption}
              cleanSelectStyles={cleanSelectStyles}
            />

            <BusinessPricingDetails
              pricingModel={pricingModel}
              setPricingModel={setPricingModel}
              pricingAmount={pricingAmount}
              setPricingAmount={setPricingAmount}
              paymentMethods={paymentMethods}
              setPaymentMethods={setPaymentMethods}
            />

            <BusinessMediaSection
              businessLogoPreview={businessLogoPreview}
              setBusinessLogoPreview={setBusinessLogoPreview}
              handleBusinessLogoSelection={handleBusinessLogoSelection}
              agentProfilePreview={agentProfilePreview}
              setAgentProfilePreview={setAgentProfilePreview}
              handleAgentProfileSelection={handleAgentProfileSelection}
              promoImagePreviews={promoImagePreviews}
              setPromoImagePreviews={setPromoImagePreviews}
              setPromoImageFiles={setPromoImageFiles}
            />

            <div
              className="footer-reg"
              onClick={!isSubmitting ? goToReviewPage : undefined}
            >
              {isSubmitting ? (
                <div className="small-loader"></div>
              ) : (
                <h3>Save & Continue ›</h3>
              )}
            </div>
          </>
        )}

        {currentStep === 2 && (
          <ReviewBusinessPage
            businessName={businessName}
            description={description}
            experience={experience}
            address={address}
            businessLogoPreview={businessLogoPreview}
            agentProfilePreview={agentProfilePreview}
            selectedReligion={selectedReligion}
            selectedCaste={selectedCaste}
            selectedCommunities={selectedCommunities}
            selectedLanuages={selectedLanuages}
            Email={Email}
            PhoneNumber={PhoneNumber}
            agentName={agentName}
            pricingModel={pricingModel}
            pricingAmount={pricingAmount}
            paymentMethods={paymentMethods}
            promoImagePreviews={promoImagePreviews}
            prevStep={prevStep}
            nextStep={nextStep}
            ReligionOptions={ReligionOptions}
            CasteOptions={casteOptions}
            CommunitiesOptions={communiteOptions}
            LanguageOptions={langOptions}
          />
        )}

        {currentStep === 3 && (
          <PaymentPage
            prevStep={prevStep}
            CreateAgent={CreateAgent}
            isSubmitting={isSubmitting}
            showSuccess={showSuccess}
            showOverlayLoader={showOverlayLoader}
          />
        )}
      </div>
    </div>
  );
}

export default Business_set_up;
